:host {
  display: block;
}

#graph {
  height: 340px;
  width: 180px;
}

.node {
  cursor: pointer;
}

.link {
  stroke: #ccc;
  stroke-width: 1px;
}

.label {
  font-size: 12px;
}

.tooltip {
  position: absolute;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  padding: 5px;
  pointer-events: none;
}

.node.primary {
  stroke: #FF0000;
}

.link.primary {
  stroke: #FF0000;
}

.node.secondary {
  stroke: #FF0000;
}

.link.secondary {
  stroke: #FF0000;
}

.arrowhead-highlighted {
  fill: red;
} 


.link-highlighted {
  stroke: red;
}
